import { useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import ApexCharts from "react-apexcharts";
import { CardFrame } from "components/UI/CardFrame";
import {
  convertMinutesToHoursAndMinutes,
  fetchMxBorderCrossKPIs,
  getDeltaMonthFormatedDate,
  getTodaysFormatedDate,
} from "components/Dashboard/helpers";
import "./CrossBorderTime.css";

const TERMINALS = ["MXNB", "MXSB"];

const formatCrossTime = (minutes) => {
  if (minutes === undefined || minutes === null) return "N/A";
  return convertMinutesToHoursAndMinutes(minutes);
};

const CrossBorderTime = () => {
  const [startDate, setStartDate] = useState(getDeltaMonthFormatedDate(6));
  const [endDate, setEndDate] = useState(getTodaysFormatedDate());
  const [kpis, setKpis] = useState({
    AvgCrossInterval: {},
    CrossingsPerMonth: {},
  });

  useEffect(() => {
    fetchMxBorderCrossKPIs(setKpis, startDate, endDate);
  }, [startDate, endDate]);

  const months = useMemo(() => {
    const mxnbMonths = Object.keys(kpis.CrossingsPerMonth?.MXNB || {});
    const mxsbMonths = Object.keys(kpis.CrossingsPerMonth?.MXSB || {});
    return Array.from(new Set([...mxnbMonths, ...mxsbMonths])).sort();
  }, [kpis]);

  const header = (
    <div className="row d-flex align-items-center">
      <div className="col">MX Border Crossing Time</div>
      <div className="col d-flex justify-content-end align-items-center">
        <div className="form-group mb-0 mr-2">
          <label className="label-text">Start:</label>
          <Form.Control
            className="btn btn-sm tab-btn"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <div className="form-group mb-0">
          <label className="label-text">End:</label>
          <Form.Control
            className="btn btn-sm tab-btn"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
      </div>
    </div>
  );

  return (
    <CardFrame title={header}>
      <div className="row mb-2">
        {TERMINALS.map((terminal) => (
          <div className="col-md-6" key={terminal}>
            <div className="mb-2">
              <div className="text-muted small">{terminal} Avg Cross Time</div>
              <div style={{ fontSize: "1.2rem", fontWeight: 600 }}>
                {formatCrossTime(kpis.AvgCrossInterval?.[terminal])}
                <span style={{ fontSize: "0.75rem", color: "#6c757d", marginLeft: 6 }}>
                  hh:mm
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <ApexCharts
        options={{
          chart: { type: "line", toolbar: { show: false } },
          stroke: { curve: "smooth", width: 3 },
          dataLabels: { enabled: false },
          xaxis: { categories: months },
          yaxis: { title: { text: "Crossings" }, min: 0 },
          legend: { position: "top" },
        }}
        series={[
          {
            name: "MXNB",
            data: months.map((month) => kpis.CrossingsPerMonth?.MXNB?.[month] ?? 0),
          },
          {
            name: "MXSB",
            data: months.map((month) => kpis.CrossingsPerMonth?.MXSB?.[month] ?? 0),
          },
        ]}
        type="line"
        height={360}
      />
      <div className="table-responsive mt-2">
        <table className="cross-border-table">
          <colgroup>
            <col className="month-col" />
            <col className="value-col" />
            <col className="value-col" />
          </colgroup>
          <thead>
            <tr>
              <th>Month</th>
              <th className="numeric">
                MXNB
              </th>
              <th className="numeric">
                MXSB
              </th>
            </tr>
          </thead>
          <tbody>
            {months.length === 0 && (
              <tr>
                <td colSpan="3" className="cross-border-empty">No data</td>
              </tr>
            )}
            {months.map((month) => (
              <tr key={month}>
                <td>{month}</td>
                <td className="numeric">
                  {kpis.CrossingsPerMonth?.MXNB?.[month] ?? 0}
                </td>
                <td className="numeric">
                  {kpis.CrossingsPerMonth?.MXSB?.[month] ?? 0}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CardFrame>
  );
};

export default CrossBorderTime;
